import { render, staticRenderFns } from "./IpsTable.vue?vue&type=template&id=2558bfa3&scoped=true"
import script from "./IpsTable.vue?vue&type=script&lang=js"
export * from "./IpsTable.vue?vue&type=script&lang=js"
import style0 from "./IpsTable.vue?vue&type=style&index=0&id=2558bfa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558bfa3",
  null
  
)

export default component.exports